module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "tableSize flipTable"
  }, [_c('tr', _vm._l((_vm.headers), function(header, n) {
    return _c('th', {
      key: n,
      staticClass: "tableHeader"
    }, [_vm._v(_vm._s(_vm.campaignType !== 'CVPIP' ? header : header !== 'UV' ? header : 'SKIP'))])
  }), 0), _vm._v(" "), _c('tbody', [_vm._l((_vm.contractData), function(contract, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n        " + _vm._s(contract.ad_knd_nm) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v("\n        " + _vm._s(contract.dp_knd_nm) + "\n      ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v(_vm._s(_vm.parseDataType(contract.contract_imp)))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "data_wrap",
      staticStyle: {
        "margin-right": "30px"
      }
    }, [_vm._v(_vm._s(_vm.parseDataType(contract.imp_cnt)))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v(_vm._s(_vm.parseDataType(contract.click_cnt)))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v(_vm._s(contract.ctr.toFixed(2)))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v(_vm._s(_vm.parseDataType(contract.cpcv)))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v(_vm._s(_vm.parseData(contract.day_rate, 'rate')))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v(_vm._s(_vm.parseData(contract.imp_rate, 'rate')))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.campaignType !== 'CVPIP' ? _vm.parseDataType(contract.uv_cnt) : _vm.parseDataType(contract.skip_cnt)) + "\n        ")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v(_vm._s(_vm.parseData(contract.play_sec_avg, 'rate')))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v(_vm._s(_vm.parseData(contract.end_rate, 'rate')))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v(_vm._s(_vm.parseData(contract.play_Q1_rate, 'rate')))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v(_vm._s(_vm.parseData(contract.play_Q2_rate, 'rate')))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v(_vm._s(_vm.parseData(contract.play_Q3_rate, 'rate')))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v(_vm._s(_vm.parseDataType(contract.budget_amt)))])])])
  }), _vm._v(" "), _c('tr', [_vm._m(0), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_c('div', {
    staticClass: "data_wrap"
  }, [_vm._v(_vm._s(_vm.parseDataType(_vm.contractTotal.imp_cnt)))])]), _vm._v(" "), _c('th', [_c('div', {
    staticClass: "data_wrap"
  }, [_vm._v(_vm._s(_vm.parseDataType(_vm.contractTotal.click_cnt)))])]), _vm._v(" "), _c('th', [_c('div', {
    staticClass: "data_wrap"
  }, [_vm._v(_vm._s(_vm.contractTotal.ctr.toFixed(2)))])]), _vm._v(" "), _c('th', [_c('div', {
    staticClass: "data_wrap"
  }, [_vm._v(_vm._s(_vm.parseDataType(_vm.contractTotal.vc)))])]), _vm._v(" "), _c('th', [_c('div', {
    staticClass: "data_wrap"
  }, [_vm._v(_vm._s(_vm.contractTotal.day_rate))])]), _vm._v(" "), _c('th', [_c('div', {
    staticClass: "data_wrap"
  }, [_vm._v(_vm._s(_vm.contractTotal.imp_rate.toFixed(1)))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_c('div', {
    staticClass: "data_wrap"
  }, [_vm._v(_vm._s(_vm.parseDataType(_vm.contractTotal.budget_amt)))])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "contract_total_text cv_table",
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("합계")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('div')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a7d1dd5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/contract/ContractInterPlayCPCV.vue
// module id = 831
// module chunks = 1